module.exports = __webpack_public_path__ + "static/media/3.a8cb9dff.jpg";